module.exports = __webpack_public_path__ + "img/undraw_teaching_re_g7e3.27ba8917.svg";